var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showRecipientsForm == "true"
      ? _c("div", [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm._t("recipients-form-label"))),
            ]),
            _vm._v(" "),
            _c("select", {
              staticClass: "form-control select2-ajax",
              attrs: {
                name: "discussion-recipients",
                id: "discussion-recipients",
                "data-placeholder": _vm._t("Search..."),
                "data-url": _vm.getRecipientsRouteWithParams(),
                "data-text_field": "text",
                multiple: "multiple",
              },
            }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showForm == "true"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "form-group", class: { "has-error": _vm.hasError } },
            [
              _c("label", { staticClass: "control-label" }, [
                _vm._v(_vm._s(_vm._t("comment-form-label")) + "*"),
              ]),
              _vm._v(" "),
              _c("comment-editor", {
                attrs: { input: _vm.commentInput, name: "commentInput" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "pull-left" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.saveComment.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm._t("Send")))]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box-group form-group", attrs: { id: "accordion" } },
      _vm._l(_vm.comments, function (comment, index) {
        return _c("div", { staticClass: "panel box bg-success" }, [
          _c("div", { staticClass: "box-header" }, [
            _c("h5", [
              _c(
                "a",
                {
                  attrs: {
                    "data-toggle": "collapse",
                    href: "#message_" + comment.id,
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(comment.creator_name) +
                      " " +
                      _vm._s(comment.creator_surname) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "mailbox-read-time pull-right" }, [
                _vm._v(
                  _vm._s(_vm._t("Sent at")) +
                    " " +
                    _vm._s(_vm._f("dateFormatted")(comment.created_at))
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "panel-collapse collapse in",
              attrs: { id: "message_" + comment.id },
            },
            [
              _c("div", { staticClass: "box-body" }, [
                _c("div", { domProps: { innerHTML: _vm._s(comment.comment) } }),
              ]),
            ]
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "nav",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.comments.length,
            expression: "comments.length",
          },
        ],
        attrs: { "aria-label": "Page navigation example" },
      },
      [
        _c(
          "ul",
          { staticClass: "pagination" },
          [
            _c(
              "li",
              {
                staticClass: "page-item",
                class: { disabled: _vm.currentPage == 1 },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "page-link",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.getCommentsPage(_vm.currentPage - 1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm._t("Previous")))]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.lastPage, function (page) {
              return _c(
                "li",
                {
                  staticClass: "page-item",
                  class: { active: page == _vm.currentPage },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      attrs: { href: "javascript:void(0);" },
                      on: {
                        click: function ($event) {
                          page != _vm.currentPage
                            ? _vm.getCommentsPage(page)
                            : false
                        },
                      },
                    },
                    [_vm._v(_vm._s(page))]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "page-item",
                class: { disabled: _vm.currentPage == _vm.lastPage },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "page-link",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.getCommentsPage(_vm.currentPage + 1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm._t("Next")))]
                ),
              ]
            ),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }